import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AnalysisTimeFrame, DateRange, timeFrameConfig } from "@trader-dashboard/shared";

type AnalysisTimeFrameSelectorProps = {
  timeFrame: AnalysisTimeFrame;
  onTimeFrameChange: (timeFrame: AnalysisTimeFrame) => void;
  customRange: DateRange;
  onCustomRangeChange: (range: DateRange) => void;
};

const dateInputClasses =
  "rounded-md border border-border bg-background px-2 py-1 text-xs text-foreground";

export const AnalysisTimeFrameSelector = ({
  timeFrame,
  onTimeFrameChange,
  customRange,
  onCustomRangeChange,
}: AnalysisTimeFrameSelectorProps): React.ReactNode => (
  <div className="flex flex-wrap items-center gap-2">
    <Tabs value={timeFrame} onValueChange={(v) => onTimeFrameChange(v as AnalysisTimeFrame)}>
      <TabsList className="h-8">
        {(Object.keys(timeFrameConfig) as AnalysisTimeFrame[]).map((key) => (
          <TabsTrigger key={key} value={key} className="px-3 py-1 text-xs">
            {timeFrameConfig[key].label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>

    {timeFrame === "custom" && (
      <div className="flex items-center gap-2">
        <input
          type="date"
          aria-label="Start date"
          value={customRange.start ?? ""}
          max={customRange.end}
          onChange={(e) => onCustomRangeChange({ ...customRange, start: e.target.value || undefined })}
          className={dateInputClasses}
        />
        <span className="text-xs text-muted-foreground">to</span>
        <input
          type="date"
          aria-label="End date"
          value={customRange.end ?? ""}
          min={customRange.start}
          onChange={(e) => onCustomRangeChange({ ...customRange, end: e.target.value || undefined })}
          className={dateInputClasses}
        />
      </div>
    )}
  </div>
);
